// 预订、入住公共api
import http from './http';

const getService = (requestUrl, params?, config?) => {
  return http({
    ...config,
    method: 'GET',
    url: requestUrl,
    params,
  });
};

const postService = (requestUrl, data?, config?) => {
  return http({
    ...config,
    method: 'POST',
    url: requestUrl,
    data,
  });
};

// 根据获取会员信息
const getMemberInfo = (data) => postService('/customers/get', data);

// 根据手机号获取会员信息
// const getInfoByPhone = (data) => getService('/customers/mobile', data);
const getInfoByPhone = (data) => postService('/customers/queryMemberInfo', data); // v2.1 接口变更 /customers/mobile -> /customers/queryMemberInfo

// 根据证件信息获取会员信息
const getInfoByIDCard = (data) => getService('customers/cert_no', data);

// 查询可预订房间列表
const getRoomList = (data) => postService('/rooms/assign/list', data);

// 自动排房
const getAssignRoom = (data) => postService('/rooms/preassign/auto', data);

// 获取当前夜审时间
const getLastAuditDate = () => getService('/sys/night-audit/last');

// 获取指定日期所在营业日V2
const getBusinessDate = (data) => postService('/sys/futureV2', data);

// 查询渠道列表
const getChannelList = (data) => getService('/channels', data);

// 查询策略列表
const getStrategyList = (data) => postService('/channels/strategy/occ-type', data);

// 根据证件信息获取预订信息
const getOrderByIDCard = (data) => postService('/reservation/transfer/smart/check/order', data);

// 查询入住单、预订单详情
const getOrderDetail = (resvNo) => getService(`/reservation/detail/${resvNo}`);

// 查询房型价格
// const getRoomPrice = (data) => postService('/channels/price', data);
// 默认非会员
const getRoomPrice = (data) =>
  postService('/channels/v2/price', { ...data, memberLevel: data.memberLevel || 0 });

// 获取房卡启用状态
const getCardStatus = () => getService('/lock/vendor/hotel/one');

// 获取主单状态
const getOrderStatus = (resvNo) => getService(`/order/detail/${resvNo}/summary`);

// 检查是否在其它门店入住
const checkGuestConflict = (data) => postService('/sub-order-occ/user/identity', data);

export default {
  getMemberInfo,
  getInfoByPhone,
  getInfoByIDCard,
  getRoomList,
  getChannelList,
  getStrategyList,
  getOrderDetail,
  getOrderByIDCard,
  getLastAuditDate,
  getAssignRoom,
  getBusinessDate,
  getRoomPrice,
  getCardStatus,
  getOrderStatus,
  checkGuestConflict,
};
